<nav class="subnav">
    <h2><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon
      ></span> PROGRAMME OFFLINE</h2>
</nav>
<p class="lead text-center"><br> The programme is currently offline.</p>